import { Component, OnInit } from '@angular/core';
import { HelpApiService, IHelp } from '@ebb-v2/ebb-integration';
import { AccountsService } from '../../../registration/services/accounts/accounts.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'registration-completed',
  templateUrl: './registrationcompleted.component.html',
  styleUrls: ['./registrationcompleted.component.scss']
})

export class RegistrationCompletedComponent implements OnInit {
  public listHelp: IHelp[] = [];
  public message: SafeHtml;
  public showMessage:boolean =false;
  public type: string;
 
  constructor( private readonly apiHelp: HelpApiService,private readonly accountsService: AccountsService,private readonly sanitizer: DomSanitizer) { 
    let ProgramType = this.accountsService.programTypeCodeOptionSet;
    if(ProgramType.includes("FEMA") || ProgramType.includes("EBB"))  {
      this.type = "ebb";
    }
    if(ProgramType.includes("ESS"))  {
      this.type  = "ess";
    }
    if(ProgramType.includes("CEA BB"))  {
      this.type  = "ceabb";
    }
    if(ProgramType.includes("EMR"))  {
      this.type = "emr";
    }
  }
  
  ngOnInit() {
    
    this.loadHelpText();
  }
  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = structuredClone(data);
          let help ="";
          if(this.type=="ebb")  {
            help ="EBB Registration Complete";
          }
          if(this.type=="ess")  {
            help ="ESS Registration Complete";
          }
          if(this.type=="ceabb")  {
            help ="CEA BB Registration Complete";
          }
          if(this.type=="emr")  {
            help ="EMR Registration Complete";
          }
          const indexHelpContractor = this.listHelp.findIndex(i => i.name === help);
          this.message =  this.sanitizer.bypassSecurityTrustHtml(this.listHelp[indexHelpContractor].answer);
          this.showMessage = true;
        },
        error => console.log(error)
      );
  }

}
